// import React, { useEffect, useRef, useState } from 'react';
// import FullCalendar from '@fullcalendar/react';
// import dayGridPlugin from '@fullcalendar/daygrid';
// import timeGridPlugin from '@fullcalendar/timegrid';
// import interactionPlugin from '@fullcalendar/interaction';
// import toast from 'react-hot-toast';
// import calendarServices from '../../core/services/calendarServices';
// import PageHeader from './ui/PageHeader';
// import Card from './ui/Card';
// import Button from './ui/Button';
// import Badge, { statusVariant } from './ui/Badge';
// import doctorServices from '../../core/services/doctorServices';

// const STATUS_COLORS = {
//   Scheduled: { bg: '#2563eb', label: 'Scheduled' },
//   Completed: { bg: '#16a34a', label: 'Completed' },
//   Cancelled: { bg: '#94a3b8', label: 'Cancelled' },
// };

// export default function CalendarView() {
//   const calendarRef = useRef(null);

//   const [events, setEvents] = useState([]);
//   const [doctors, setDoctors] = useState([]);
//   const [rooms, setRooms] = useState([]);
//   const [filters, setFilters] = useState({ doctor_id: '', room_id: '' });
//   const [selectedEvent, setSelectedEvent] = useState(null);
//   const [dateRange, setDateRange] = useState({ start: '', end: '' });
//   const [loading, setLoading] = useState(false);

//   // ---------------- LOAD DROPDOWNS ----------------
//   const normalizeDropdownResponse = (response) => {
//     if (!response) return [];
//     if (Array.isArray(response?.data?.data)) return response.data.data;
//     if (Array.isArray(response?.accresp?.personList)) return response.accresp.personList;
//     if (Array.isArray(response?.roomList)) return response.roomList;
//     if (Array.isArray(response?.personList)) return response.personList;
//     if (Array.isArray(response?.data)) return response.data;
//     if (Array.isArray(response)) return response;
//     return [];
//   };

//   useEffect(() => {
//     const fetchDropdowns = async () => {
//       try {
//         const [d, r] = await Promise.all([
//           doctorServices.getDoctorList(),  
//           calendarServices.getRooms(),
//         ]);

//         setDoctors(normalizeDropdownResponse(d));
//         setRooms(normalizeDropdownResponse(r));
//       } catch (err) {
//         toast.error('Failed to load filters');
//       }
//     };

//     fetchDropdowns();
//   }, []);

//   // ---------------- FETCH EVENTS ----------------
//   const fetchEvents = async (start, end) => {
//     if (!start || !end) return;

//     setLoading(true);

//     try {
//       // Build pure explicit URL search params structure
//       const queryParams = {
//         date_from: start,
//         date_to: end,
//         limit: 10,
//       };

//       // Ensure the key strings perfectly match your expected backend parameters
//       if (filters.doctor_id) {
//         queryParams.doctor_id = filters.doctor_id;
//       }
//       if (filters.room_id) {
//         queryParams.room_id = filters.room_id;
//       }

//       const urlParams = new URLSearchParams(queryParams);
//       const res = await calendarServices.getSessions(urlParams);
//       const sessions = res.data?.data || res.data || [];

//       const formattedEvents = sessions.map((event) => {
//         const patientName = `${event.fname || ''} ${event.mname || ''} ${event.lname || ''}`.trim() || `Booking #${event.id}`;

//         return {
//           id: String(event.id),
//           title: patientName,
//           start: `${event.sessionDate}T${event.startTime}`,
//           end: `${event.sessionDate}T${event.endTime}`,
//           extendedProps: event,
//           backgroundColor: STATUS_COLORS[event.status]?.bg || '#2563eb',
//           borderColor: STATUS_COLORS[event.status]?.bg || '#2563eb',
//         };
//       });

//       // Constructing a fresh array reference forces FullCalendar to redraw layout layers
//       setEvents([...formattedEvents]);
//     } catch (err) {
//       toast.error('Failed to load calendar events');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // ---------------- FILTER AND RANGE SYNC ----------------
//   useEffect(() => {
//     if (dateRange.start && dateRange.end) {
//       fetchEvents(dateRange.start, dateRange.end);
//     }
//   }, [filters, dateRange]);

//   // ---------------- DATE RANGE ----------------
//   const handleDatesSet = (info) => {
//     const start = info.startStr.split('T')[0];
//     const end = info.endStr.split('T')[0];
//     setDateRange({ start, end });
//   };

//   return (
//     <div className="page-container fade-in">
//       <PageHeader
//         eyebrow="Calendar"
//         title="Scheduling Calendar"
//         subtitle="Week, day, and month views for treatment sessions and appointments."
//         actions={
//           <>
//             <select
//               className="form-control"
//               value={filters.doctor_id}
//               onChange={(e) =>
//                 setFilters((p) => ({
//                   ...p,
//                   doctor_id: e.target.value,
//                 }))
//               }
//             >
//               <option value="">All Doctors</option>
//               {doctors.map((d) => (
//                 <option key={d.id} value={d.id}>
//                   {d.name || `${d.first_name || ''} ${d.last_name || ''}`}
//                 </option>
//               ))}
//             </select>

//             <select
//               className="form-control"
//               value={filters.room_id}
//               onChange={(e) =>
//                 setFilters((p) => ({
//                   ...p,
//                   room_id: e.target.value,
//                 }))
//               }
//             >
//               <option value="">All Rooms</option>
//               {rooms.map((r) => (
//                 <option key={r.id} value={r.id}>
//                   {r.roomCode ? `${r.roomCode} - ` : ''}
//                   {r.roomName}
//                 </option>
//               ))}
//             </select>
//           </>
//         }
//       />

//       <Card className="chart-card">
//         <div className="d-flex align-items-center gap-3 mb-4">
//           {Object.entries(STATUS_COLORS).map(([key, val]) => (
//             <Badge key={key} variant={statusVariant(key)}>
//               <span
//                 style={{
//                   width: 8,
//                   height: 8,
//                   borderRadius: 99,
//                   background: val.bg,
//                   display: 'inline-block',
//                 }}
//               />
//               {val.label}
//             </Badge>
//           ))}

//           {loading && (
//             <div className="spinner" style={{ marginLeft: 'auto' }} />
//           )}
//         </div>

//         <div className="calendar-wrapper">
//           <FullCalendar
//             ref={calendarRef}
//             plugins={[
//               dayGridPlugin,
//               timeGridPlugin,
//               interactionPlugin,
//             ]}
//             initialView="timeGridWeek"
//             headerToolbar={{
//               left: 'prev,next today',
//               center: 'title',
//               right: 'dayGridMonth,timeGridWeek,timeGridDay',
//             }}
//             events={events}
//             datesSet={handleDatesSet}
//             eventClick={(info) => {
//               setSelectedEvent(info.event.extendedProps);
//             }}
//             slotMinTime="06:00:00"
//             slotMaxTime="21:00:00"
//             height="auto"
//             allDaySlot={false}
//             nowIndicator
//             eventDisplay="block"
//             eventContent={(info) => {
//               const props = info.event.extendedProps;
//               const patientName = `${props.fname || ''} ${props.lname || ''}`.trim() || `Booking #${props.id}`;
              
//               return (
//                 <div
//                   style={{
//                     padding: 4,
//                     color: 'white',
//                     height: '100%',
//                     overflow: 'hidden',
//                   }}
//                 >
//                   <div
//                     style={{
//                       fontWeight: 800,
//                       fontSize: '0.75rem',
//                       marginBottom: 2,
//                     }}
//                   >
//                     {patientName}
//                   </div>

//                   <div style={{ fontSize: '0.65rem', opacity: 0.9 }}>
//                     {props.treatment_name || props.product_name}
//                   </div>

//                   <div
//                     style={{
//                       fontSize: '0.65rem',
//                       fontWeight: 700,
//                     }}
//                   >
//                     {props.roomname || 'No room assigned'}
//                   </div>
//                 </div>
//               );
//             }}
//           />
//         </div>
//       </Card>

//       {/* MODAL ACTIVATION BLOCK */}
//       {selectedEvent && (
//         <div
//           className="modal-overlay"
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: 'rgba(0, 0, 0, 0.5)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             zIndex: 9999,
//           }}
//           onClick={() => setSelectedEvent(null)}
//         >
//           <div
//             className="modal-content"
//             style={{
//               background: '#fff',
//               padding: '24px',
//               borderRadius: '8px',
//               maxWidth: '480px',
//               width: '100%',
//               boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
//             }}
//             onClick={(e) => e.stopPropagation()}
//           >
//             <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px' }}>
//               <h3 style={{ margin: 0, cursor: 'default', userSelect: 'none' }}>Appointment Details</h3>
//               <button
//                 className="modal-close"
//                 style={{ background: 'none', border: 'none', fontSize: '1.25rem', cursor: 'default' }}
//                 onClick={() => setSelectedEvent(null)}
//               >
//                 &times;
//               </button>
//             </div>

//             <div className="modal-body" style={{ padding: '16px 0', display: 'flex', flexDirection: 'column', gap: '10px', color: '#334155' }}>
//               <div><strong>Patient Name:</strong> {`${selectedEvent.fname || ''} ${selectedEvent.lname || ''}`.trim() || 'N/A'}</div>
//               <div><strong>Contact Number:</strong> {selectedEvent.phno || 'N/A'}</div>
//               <div><strong>Treatment:</strong> {selectedEvent.treatment_name || 'N/A'}</div>
//               <div><strong>Room Assigned:</strong> {selectedEvent.roomname || 'No Room Allocated'}</div>
//               <div><strong>Booking Code:</strong> {selectedEvent.booking_code || 'N/A'}</div>
//               <div><strong>Date:</strong> {selectedEvent.sessionDate}</div>
//               <div><strong>Time Window:</strong> {selectedEvent.startTime} - {selectedEvent.endTime}</div>
//               <div>
//                 <strong>Status:</strong>{' '}
//                 <Badge variant={statusVariant(selectedEvent.status)}>
//                   {selectedEvent.status}
//                 </Badge>
//               </div>
//             </div>

//             <div className="modal-footer" style={{ borderTop: '1px solid #e2e8f0', paddingTop: '12px', display: 'flex', justifyContent: 'flex-end' }}>
//               <Button onClick={() => setSelectedEvent(null)}>
//                 Close Details
//               </Button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
import React, { useEffect, useRef, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import toast from 'react-hot-toast';
import calendarServices from '../../core/services/calendarServices';
import PageHeader from './ui/PageHeader';
import Card from './ui/Card';
import Button from './ui/Button';
import Badge, { statusVariant } from './ui/Badge';
import doctorServices from '../../core/services/doctorServices';

const STATUS_META = {
  Scheduled: { bg: '#2563eb', border: '#1d4ed8', dot: '#93c5fd', label: 'Scheduled' },
  Onboarded: { bg: '#7c3aed', border: '#6d28d9', dot: '#c4b5fd', label: 'Onboarded' },
  Completed: { bg: '#16a34a', border: '#15803d', dot: '#86efac', label: 'Completed' },
  Cancelled: { bg: '#94a3b8', border: '#64748b', dot: '#e2e8f0', label: 'Cancelled' },
};

const resolveMeta = (status) =>
  STATUS_META[status] || STATUS_META.Scheduled;

const getPatientName = (e) =>
  [`${e.fname || ''} ${e.mname || ''} ${e.lname || ''}`.trim(),
   e.patient_name, e.patientName, e.name]
    .find(Boolean) || `Booking #${e.id}`;

const getDoctorName = (e) =>
  [e.doctor_name, e.doctorName,
   `${e.doctor_first || ''} ${e.doctor_last || ''}`.trim()]
    .find(Boolean) || 'Unassigned';

const getRoomDisplay = (e) => {
  const code = e.room_code || e.roomCode || '';
  const name = e.roomname || e.room_name || e.room_number || '';
  if (!code && !name) return 'No room';
  return code ? `${code} - ${name}` : name;
};

const getTreatment = (e) =>
  e.package_name || e.packageName||e.treatment_name || e.product_name || e.package_name || e.packageName || '';

const fmtTime = (t) => (t ? t.slice(0, 5) : '');

export default function CalendarView() {
  const calendarRef = useRef(null);
  const [events,        setEvents]        = useState([]);
  const [doctors,       setDoctors]       = useState([]);
  const [rooms,         setRooms]         = useState([]);
  const [filters,       setFilters]       = useState({ doctor_id: '', room_id: '' });
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [dateRange,     setDateRange]     = useState({ start: '', end: '' });
  const [loading,       setLoading]       = useState(false);

  const normalise = (res) => {
    if (!res) return [];
    if (Array.isArray(res?.data?.data))          return res.data.data;
    if (Array.isArray(res?.accresp?.personList)) return res.accresp.personList;
    if (Array.isArray(res?.roomList))            return res.roomList;
    if (Array.isArray(res?.personList))          return res.personList;
    if (Array.isArray(res?.data))                return res.data;
    if (Array.isArray(res))                      return res;
    return [];
  };

  useEffect(() => {
    (async () => {
      try {
        const [d, r] = await Promise.all([
          doctorServices.getDoctorList(),
          calendarServices.getRooms(),
        ]);
        setDoctors(normalise(d).filter(Boolean));
        setRooms(normalise(r).filter(Boolean));
      } catch {
        toast.error('Failed to load filters');
      }
    })();
  }, []);

  const fetchEvents = async (start, end) => {
    if (!start || !end) return;
    setLoading(true);
    try {
      const q = new URLSearchParams({ date_from: start, date_to: end, limit: 200 });
      if (filters.doctor_id) q.set('doctor_id', filters.doctor_id);
      if (filters.room_id)   q.set('room_id',   filters.room_id);

      const res      = await calendarServices.getSessions(q);
      const sessions = res.data?.data || res.data || [];

      setEvents(
        sessions.map((e) => {
          const meta = resolveMeta(e.status);
          return {
            id:              String(e.id),
            title:           getPatientName(e),
            start:           `${e.sessionDate}T${e.startTime}`,
            end:             `${e.sessionDate}T${e.endTime}`,
            extendedProps:   e,
            backgroundColor: meta.bg,
            borderColor:     meta.border,
            textColor:       '#fff',
          };
        })
      );
    } catch {
      toast.error('Failed to load calendar events');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (dateRange.start && dateRange.end) fetchEvents(dateRange.start, dateRange.end);
  }, [filters, dateRange]); // eslint-disable-line

  const handleDatesSet = (info) => {
    setDateRange({
      start: info.startStr.split('T')[0],
      end:   info.endStr.split('T')[0],
    });
  };

  // ── Event card ───────────────────────────────────────
  const renderEventContent = (info) => {
    const e       = info.event.extendedProps;
    const patient = getPatientName(e);
    const doctor  = getDoctorName(e);
    const meta    = resolveMeta(e.status);
    const start   = fmtTime(e.startTime);
    const end     = fmtTime(e.endTime);

    return (
      <div style={{
        padding:       '4px 7px 5px',
        height:        '100%',
        overflow:      'hidden',
        display:       'flex',
        flexDirection: 'column',
        gap:           3,
        cursor:        'pointer',
        boxSizing:     'border-box',
        opacity:       e.status === 'Cancelled' ? 0.7 : 1,
      }}>

        {/* Row 1: time + status pill */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'nowrap' }}>
          {/* Time */}
          <span style={{
            fontSize:      '0.65rem',
            fontWeight:    700,
            opacity:       0.92,
            whiteSpace:    'nowrap',
            letterSpacing: 0.2,
          }}>
            {start} – {end}
          </span>

          {/* Status pill */}
          <span style={{
            fontSize:      '0.55rem',
            fontWeight:    700,
            background:    'rgba(255,255,255,0.22)',
            border:        `1px solid rgba(255,255,255,0.35)`,
            borderRadius:  20,
            padding:       '1px 6px',
            whiteSpace:    'nowrap',
            letterSpacing: 0.3,
            textTransform: 'uppercase',
            display:       'flex',
            alignItems:    'center',
            gap:           3,
          }}>
            {/* Status dot */}
            <span style={{
              width:        5,
              height:       5,
              borderRadius: '50%',
              background:   meta.dot,
              display:      'inline-block',
              flexShrink:   0,
            }} />
            {meta.label}
          </span>
        </div>

        {/* Row 2: patient name */}
        <div style={{
          fontSize:     '0.78rem',
          fontWeight:   800,
          lineHeight:   1.2,
          whiteSpace:   'nowrap',
          overflow:     'hidden',
          textOverflow: 'ellipsis',
        }}>
          {patient}
        </div>

        {/* Row 3: doctor */}
        <div style={{
          fontSize:     '0.62rem',
          fontWeight:   500,
          opacity:      0.85,
          whiteSpace:   'nowrap',
          overflow:     'hidden',
          textOverflow: 'ellipsis',
        }}>
          Dr. {doctor}
        </div>

      </div>
    );
  };

  return (
    <div className="page-container fade-in">
      <PageHeader
        eyebrow="Calendar"
        title="Scheduling Calendar"
        actions={
          <>
            <select
              className="form-control"
              style={{ minWidth: 160 }}
              value={filters.doctor_id}
              onChange={(e) => setFilters((p) => ({ ...p, doctor_id: e.target.value }))}
            >
              <option value="">All Doctors</option>
              {doctors.map((d) => {
                const id = d.id || d.personId || d.doctorId || d.userId;
                return (
                  <option key={id} value={id}>
                    {d.name || `${d.first_name || ''} ${d.last_name || ''}`.trim() || d.personName}
                  </option>
                );
              })}
            </select>

            <select
              className="form-control"
              style={{ minWidth: 160 }}
              value={filters.room_id}
              onChange={(e) => setFilters((p) => ({ ...p, room_id: e.target.value }))}
            >
              <option value="">All Rooms</option>
              {rooms.map((r) => (
                <option key={r.id || r.roomId} value={r.id || r.roomId}>
                  {r.roomCode ? `${r.roomCode} – ` : ''}{r.roomName}
                </option>
              ))}
            </select>
          </>
        }
      />

      <Card className="chart-card">
        {/* Legend */}
        <div className="d-flex align-items-center gap-3 mb-3" style={{ flexWrap: 'wrap' }}>
          {Object.entries(STATUS_META).map(([key, val]) => (
            <span key={key} style={{
              display:      'inline-flex',
              alignItems:   'center',
              gap:          6,
              fontSize:     13,
              fontWeight:   600,
              color:        '#475569',
            }}>
              <span style={{
                width:        10,
                height:       10,
                borderRadius: '50%',
                background:   val.bg,
                display:      'inline-block',
              }} />
              {val.label}
            </span>
          ))}
          {loading && <div className="spinner" style={{ marginLeft: 'auto' }} />}
        </div>

        <style>{`
          .fc-timegrid-event {
            border-radius: 7px !important;
            box-shadow: 0 2px 6px rgba(0,0,0,0.15) !important;
            min-height: 56px !important;
          }
          .fc-timegrid-event .fc-event-main {
            padding: 0 !important;
          }
          .fc-daygrid-event {
            border-radius: 5px !important;
            padding: 2px 6px !important;
            font-size: 0.75rem !important;
            font-weight: 700 !important;
          }
          .fc-day-today { background: #fffbeb !important; }
          .fc-col-header-cell-cushion { font-weight: 700; color: #1e40af; }
          .fc-timegrid-slot-label-cushion { font-size: 0.72rem; color: #64748b; }
          /* remove fc's own time label inside the event so ours is the only one */
          .fc-event-time { display: none !important; }
          .fc-event-title { display: none !important; }
        `}</style>

        <div className="calendar-wrapper">
          <FullCalendar
            ref={calendarRef}
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="timeGridWeek"
            headerToolbar={{
              left:   'prev,next today',
              center: 'title',
              right:  'dayGridMonth,timeGridWeek,timeGridDay',
            }}
            events={events}
            datesSet={handleDatesSet}
            eventClick={(info) => setSelectedEvent(info.event.extendedProps)}
            eventContent={renderEventContent}
            slotMinTime="06:00:00"
            slotMaxTime="21:00:00"
            height="auto"
            expandRows
            allDaySlot={false}
            nowIndicator
            eventDisplay="block"
            slotEventOverlap={false}
            eventMaxStack={3}
            slotDuration="00:30:00"
            snapDuration="00:15:00"
          />
        </div>
      </Card>

      {/* ── Detail modal ── */}
      {selectedEvent && (
        <div
          style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999 }}
          onClick={() => setSelectedEvent(null)}
        >
          <div
            style={{ background: '#fff', padding: 28, borderRadius: 14, maxWidth: 500, width: '94%', boxShadow: '0 12px 40px rgba(0,0,0,0.22)' }}
            onClick={(ev) => ev.stopPropagation()}
          >
            {/* Modal header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 18 }}>
              <div>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#2563eb', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>
                  Appointment Details
                </div>
                <h3 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: '#0f172a' }}>
                  {getPatientName(selectedEvent)}
                </h3>
              </div>
              <button
                style={{ background: '#f1f5f9', border: 'none', borderRadius: '50%', width: 34, height: 34, fontSize: '1.2rem', cursor: 'pointer', color: '#64748b', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}
                onClick={() => setSelectedEvent(null)}
              >×</button>
            </div>

            {/* Status */}
            <div style={{ marginBottom: 18 }}>
              <span style={{
                display:       'inline-flex',
                alignItems:    'center',
                gap:           6,
                background:    resolveMeta(selectedEvent.status).bg,
                color:         '#fff',
                fontSize:      12,
                fontWeight:    700,
                borderRadius:  20,
                padding:       '4px 12px',
                letterSpacing: 0.4,
              }}>
                <span style={{ width: 7, height: 7, borderRadius: '50%', background: resolveMeta(selectedEvent.status).dot, display: 'inline-block' }} />
                {selectedEvent.status}
              </span>
            </div>

            {/* Detail grid */}
            <div style={{ display: 'grid', gridTemplateColumns: '110px 1fr', rowGap: 11, fontSize: 14, color: '#334155' }}>
              {[
                ['Date',         selectedEvent.sessionDate || 'N/A'],
                ['Time',         `${fmtTime(selectedEvent.startTime)} – ${fmtTime(selectedEvent.endTime)}`],
                ['Doctor',       `Dr. ${getDoctorName(selectedEvent)}`],
                ['Contact',      selectedEvent.phno || 'N/A'],
                // ['Treatment',    getTreatment(selectedEvent) || 'N/A'],
                ['Room',         getRoomDisplay(selectedEvent)],
                ['Booking Code', selectedEvent.booking_code || 'N/A'],
              ].map(([label, value]) => (
                <React.Fragment key={label}>
                  <span style={{ fontWeight: 600, color: '#94a3b8', fontSize: 12, paddingTop: 1 }}>{label}</span>
                  <span style={{ fontWeight: 600, color: '#1e293b' }}>{value}</span>
                </React.Fragment>
              ))}
            </div>

            <div style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end' }}>
              <Button onClick={() => setSelectedEvent(null)}>Close</Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}